import { ThemeProvider } from './shared/contexts/ThemeProvider';
import { PublicIdentityProvider } from './shared/brand/PublicIdentityContext';
import { ToastProvider } from './shared/contexts/ToastProvider';
import { ConfirmationProvider } from './shared/contexts/ConfirmationProvider';
import { AuthProvider } from './features/auth';
import { LicenseProvider } from './features/license/LicenseProvider';
import { AppRouter } from './router';

export default function App() {
  return (
    <ThemeProvider>
      <PublicIdentityProvider>
        <ToastProvider>
          <ConfirmationProvider>
            <AuthProvider>
              <LicenseProvider>
                <AppRouter />
              </LicenseProvider>
            </AuthProvider>
          </ConfirmationProvider>
        </ToastProvider>
      </PublicIdentityProvider>
    </ThemeProvider>
  );
}
